// extracted by mini-css-extract-plugin
module.exports = {"strength":"Strength_strength__fIj5M","strength__bar":"Strength_strength__bar__Z2Rdu","strength__text":"Strength_strength__text__01XaB"};